(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marcel-box-builder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('marcel-box-builder')) {
  customElements.define('marcel-box-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.items = new Map();
      this.busy = false;
      this.uncertain = false;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {style: 'currency', currency: this.dataset.currency || 'AUD'});
      this.submit = this.querySelector('[data-submit]');
      this.status = this.querySelector('[data-status]');
      this.addEventListener('change', e => {
        if (e.target.tagName === 'SELECT') e.target.closest('article').querySelector('.marcel-box__price').textContent = this.money.format(Number(e.target.selectedOptions[0].dataset.price) / 100);
      });
      this.addEventListener('click', e => {
        const filter = e.target.closest('[data-filter]');
        if (filter) {
          this.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
          let visible = 0;
          this.querySelectorAll('[data-category]').forEach(card => {
            card.hidden = filter.dataset.filter !== 'all' && card.dataset.category !== filter.dataset.filter;
            if (!card.hidden) visible++;
          });
          this.querySelector('[data-filter-empty]').hidden = visible > 0;
        }
        const add = e.target.closest('[data-add]');
        if (add && !this.busy && !this.uncertain) {
          const card = add.closest('article');
          const input = card.querySelector('input');
          if (!input.reportValidity()) return;
          const option = card.querySelector('select').selectedOptions[0];
          if (!option || option.disabled) return;
          const id = option.value;
          const qty = Number(input.value);
          const previous = this.items.get(id);
          const title = card.dataset.title + (card.querySelector('select').hidden ? '' : ' — ' + option.textContent.split(' — ')[0]);
          this.items.set(id, {id, title, price: Number(option.dataset.price), quantity: Math.min(100, (previous?.quantity || 0) + qty)});
          this.render();
          this.status.textContent = title + ' × ' + this.items.get(id).quantity;
        }
        const change = e.target.closest('[data-delta]');
        if (change && !this.busy && !this.uncertain) {
          const item = this.items.get(change.dataset.id);
          item.quantity = Math.min(100, item.quantity + Number(change.dataset.delta));
          if (item.quantity < 1) this.items.delete(item.id);
          this.render();
        }
        if (e.target.closest('[data-submit]')) this.addBox();
      });
      this.render();
    }
    render() {
      const list = this.querySelector('[data-items]');
      list.replaceChildren();
      let total = 0;
      for (const item of this.items.values()) {
        total += item.price * item.quantity;
        const li = document.createElement('li');
        const title = document.createElement('strong');
        title.textContent = item.title;
        const row = document.createElement('div');
        row.className = 'marcel-box__row';
        for (const delta of [-1, 1]) {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.delta = delta;
          button.dataset.id = item.id;
          button.textContent = delta < 0 ? '−' : '+';
          button.setAttribute('aria-label', (delta < 0 ? '− ' : '+ ') + item.title);
          row.append(button);
          if (delta < 0) { const qty = document.createElement('span'); qty.textContent = item.quantity; row.append(qty); }
        }
        const amount = document.createElement('span');
        amount.textContent = this.money.format(item.price * item.quantity / 100);
        row.append(amount);
        li.append(title, row);
        list.append(li);
      }
      this.querySelector('[data-total]').textContent = this.money.format(total / 100);
      this.querySelector('[data-empty]').hidden = this.items.size > 0;
      this.submit.disabled = this.items.size === 0 || this.busy || this.uncertain;
    }
    async addBox() {
      if (this.busy || this.uncertain || !this.items.size) return;
      this.busy = true;
      this.setAttribute('aria-busy', 'true');
      this.render();
      const boxId = crypto.randomUUID();
      const items = [...this.items.values()].map(item => ({id: item.id, quantity: item.quantity, properties: {Box: this.dataset.boxLabel, _marcel_box_id: boxId}}));
      try {
        const response = await fetch(this.dataset.addUrl, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
        if (!response.ok) throw new Error('cart');
        await response.json();
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.uncertain = true;
        this.status.textContent = this.dataset.error;
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.render();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
